export const SET_CURRENT_HOLTER = 'SET_CURRENT_HOLTER'
export const SET_HOLTER_LOADING = 'SET_HOLTER_LOADING'
